// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserManagement_root__IYYfK {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  color: var(--color-font-10);
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
}

.UserManagement_user_management_container__4GcFk {
  display: flex;
}

.UserManagement_user_list_container__YZ-UH {
  position: fixed;
  left: 210px;
  top: 91px;
  width: 290px;
  background-color: var(--color-bg-caselist);
  overflow: scroll;
  padding: 10px;
  overflow-x: hidden;
  height: calc(100vh - 140px);
}

.UserManagement_tabs_and_content_container__r6Gx2 {
  width: 950px;
  overflow: hidden;
  margin-left: 310px;
  background-color: var(--color-bg-content);
}

.UserManagement_add_user_container__snJVi {
  background-color: var(--color-bg-caselist);
  display: flex;
  justify-content: flex-end;
}

.UserManagement_btn_add_user__yu0ef {
  font-weight: 600 !important;
  color: var(--color-theme-10) !important;
  height: 40px;
  line-height: 0px !important;
}

.UserManagement_btn_add_user__yu0ef:hover {
  color: var(--color-theme-blue) !important;
  background-color: var(--color-theme-lightblue) !important;
}

.UserManagement_plus_sign__FqF\\+N {
  margin-right: 10px;
  font-size: 20px;
}

.UserManagement_user_no_data__NHUQh {
  text-align: center;
  margin-top: 300px;
  text-transform: uppercase;
  font-size: 24px;
  color: var(--color-theme-silver);
}

.UserManagement_user_states_container__KGh1n {
  display: flex;
  align-items: flex-end;
}

.UserManagement_user_state_col__zNVH0 {
  padding-right: 20px;
}

.UserManagement_user_state_col__zNVH0 p {
  padding: 0px;
  margin: 0px;
  font-size: 11px !important;
  cursor: default;
  line-height: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/UserManagement/UserManagement.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAGlB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  color: var(--color-font-10);\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.user_management_container {\n  display: flex;\n}\n\n.user_list_container {\n  position: fixed;\n  left: 210px;\n  top: 91px;\n  width: 290px;\n  background-color: var(--color-bg-caselist);\n  overflow: scroll;\n  padding: 10px;\n  overflow-x: hidden;\n  height: -webkit-calc(100vh - 105px);\n  height: -moz-calc(100vh - 105px);\n  height: calc(100vh - 140px);\n}\n\n.tabs_and_content_container {\n  width: 950px;\n  overflow: hidden;\n  margin-left: 310px;\n  background-color: var(--color-bg-content);\n}\n\n.add_user_container {\n  background-color: var(--color-bg-caselist);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn_add_user {\n  font-weight: 600 !important;\n  color: var(--color-theme-10) !important;\n  height: 40px;\n  line-height: 0px !important;\n}\n\n.btn_add_user:hover {\n  color: var(--color-theme-blue) !important;\n  background-color: var(--color-theme-lightblue) !important;\n}\n\n.plus_sign {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.user_no_data {\n  text-align: center;\n  margin-top: 300px;\n  text-transform: uppercase;\n  font-size: 24px;\n  color: var(--color-theme-silver);\n}\n\n.user_states_container {\n  display: flex;\n  align-items: flex-end;\n}\n\n.user_state_col {\n  padding-right: 20px;\n}\n\n.user_state_col p {\n  padding: 0px;\n  margin: 0px;\n  font-size: 11px !important;\n  cursor: default;\n  line-height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UserManagement_root__IYYfK`,
	"user_management_container": `UserManagement_user_management_container__4GcFk`,
	"user_list_container": `UserManagement_user_list_container__YZ-UH`,
	"tabs_and_content_container": `UserManagement_tabs_and_content_container__r6Gx2`,
	"add_user_container": `UserManagement_add_user_container__snJVi`,
	"btn_add_user": `UserManagement_btn_add_user__yu0ef`,
	"plus_sign": `UserManagement_plus_sign__FqF+N`,
	"user_no_data": `UserManagement_user_no_data__NHUQh`,
	"user_states_container": `UserManagement_user_states_container__KGh1n`,
	"user_state_col": `UserManagement_user_state_col__zNVH0`
};
export default ___CSS_LOADER_EXPORT___;
